import { useEffect, useState } from 'react';
import { Stack, Title, Text, Paper, Button, Group, Box } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { PRIZE_AUTO_RETURN_MS } from '../../utils/cvdl';
import { useKiosk } from '../../context/KioskContext/KioskContext';
import { api } from '../../wheel-api/client';
import { BotonesImpresion } from './BotonesImpresion';
import { componerPremio } from '../../utils/impresion';

export function PrizeScreen() {
  const { spinResult, attendee, reset } = useKiosk();
  const [enviando, setEnviando] = useState(false);
  const [imprimiendo, setImprimiendo] = useState(false);
  const [hoja, setHoja] = useState(null);
  const nombre = (spinResult?.name || attendee?.name || '').split(' ')[0].toUpperCase();

  // Si esta enviando el codigo o imprimiendo, no la pateamos al atractor.
  useEffect(() => {
    if (enviando || imprimiendo) return;
    const t = setTimeout(reset, PRIZE_AUTO_RETURN_MS);
    return () => clearTimeout(t);
  }, [reset, enviando, imprimiendo]);

  // El ticket se compone apenas se conoce el premio: al tocar el boton ya
  // tiene que estar listo, porque navigator.share exige el gesto del usuario.
  useEffect(() => {
    if (!spinResult) return;
    let vivo = true;
    const vence = spinResult.expiresAt
      ? new Date(spinResult.expiresAt).toLocaleDateString('es-AR',
          { day: '2-digit', month: '2-digit', year: 'numeric' })
      : null;

    componerPremio({
      nombre,
      titulo: spinResult.prize?.shortLabel || spinResult.prizeLabel,
      detalle: spinResult.prize?.label,
      codigo: spinResult.code,
      instrucciones: spinResult.prize?.instructions,
      vence,
    })
      .then(b => { if (vivo) setHoja(b); })
      .catch(err => console.error('[premio/impresion]', err));

    return () => { vivo = false; };
  }, [spinResult, nombre]);

  if (!spinResult) return null;
  const yaGiro = spinResult.alreadySpun;

  return (
    <Stack align="center" justify="center" style={{ flex: 1 }} gap="lg" px="8%">
      <Title order={1} ta="center" style={{ fontSize: 'clamp(28px, 5vh, 52px)' }}>
        {yaGiro ? `YA GIRASTE HOY, ${nombre} 🙂` : `¡GANASTE, ${nombre}!`}
      </Title>

      <Paper withBorder radius="lg" p="xl" w="100%" maw={620}
             style={{ borderWidth: 3, borderColor: 'var(--mantine-color-forvet-7)' }}>
        <Stack align="center" gap="xs">
          <Text fw={900} style={{ fontSize: 'clamp(24px, 4vh, 40px)' }} ta="center">
            {spinResult.prize?.shortLabel || spinResult.prizeLabel}
          </Text>
          <Text size="xl" c="dimmed" ta="center">
            {spinResult.prize?.label || ''}
          </Text>

          {spinResult.code && (
            <Box mt="md" ta="center">
              <Text size="lg" c="dimmed">Tu código</Text>
              <Text ff="monospace" fw={900} style={{ fontSize: 'clamp(32px, 6vh, 56px)', letterSpacing: 4 }}>
                {spinResult.code}
              </Text>
            </Box>
          )}

          {spinResult.prize?.instructions && (
            <Text size="lg" ta="center" mt="sm">{spinResult.prize.instructions}</Text>
          )}
        </Stack>
      </Paper>

      {yaGiro && (
        <Text size="xl" ta="center" maw={700}>
          Volvé mañana y girás de nuevo. Y acordate: el viernes a las 17 sorteamos
          la beca del 100%, hay que estar acá.
        </Text>
      )}

      <BotonesImpresion
        blob={hoja}
        nombreArchivo={`premio-${spinResult.code || spinResult.prizeSlot || 'forvet'}.png`}
        titulo="Premio FORVET"
        onUso={() => setImprimiendo(true)}
      />

      <Group>
        {spinResult.code && (
          <Button variant="outline" loading={enviando} onClick={async () => {
            setEnviando(true);
            try {
              await api.resendCode(spinResult.spinId);
              notifications.show({ message: 'Te lo mandamos por WhatsApp', color: 'green' });
            } catch {
              notifications.show({ message: 'No pudimos enviarlo. Anotá el código.', color: 'orange' });
            } finally { setEnviando(false); }
          }}>
            {yaGiro ? 'REENVIARME MI CÓDIGO' : 'ENVIARME EL CÓDIGO'}
          </Button>
        )}
        <Button onClick={reset}>LISTO</Button>
      </Group>
    </Stack>
  );
}